<app-funnel-shell>
  <div class="funnel-card" style="text-align: center;">
    @if (loading()) {
      <h2>{{ 'funnel.quiz_start.loading' | translate }}</h2>
      <p class="funnel-card__intro">{{ 'funnel.quiz_start.loading_hint' | translate }}</p>
    }
    @if (error()) {
      <h2>{{ 'funnel.quiz_start.error_title' | translate }}</h2>
      <p class="funnel-card__intro">{{ error() }}</p>
      <p class="funnel-card__footnote">{{ 'funnel.quiz_start.error_hint' | translate }}</p>
    }
  </div>
</app-funnel-shell>
